
import React from 'react'
import { Link } from 'react-router-dom'

function Shippingexchange(props) {
  return (
    <div>
        


        {/* Start Breadcrumb area  */}
      <div className="index-one">
          <main>
           <div className="breadcrumb-area bg_image tmp-section-gap breadcrumb-bg">
            <div className="container">
            <div className="row">
                <div className="col-lg-12">
                <div className="breadcrumb-inner text-center">
                    <h1 className="title split-collab">Shipping and Exchange</h1>
                    <ul className="page-list">
                    <li className="tmp-breadcrumb-item">
                        <a href="/">Home</a>
                    </li>
                    <li className="icon">
                        <i className="fa-solid fa-angle-right" />
                    </li>
                    <li className="tmp-breadcrumb-item active">
                    Shipping and Exchange</li>
                    </ul>
                    <div className="circle-1" />
                </div>
                </div>
            </div>
            </div>
        </div>
        <section className="privacy-policy-section tmp-section-gap">
  <div className="container">
    <div className="row">
      <div className="col-lg-12">
        <div className="inner">
          <div className="section-head text-align-left">
            <h2 className="section-title">Shipping & Exchange Policy</h2>
          </div>

          <p className="description">
            At Vaishnav To Vaishnav Business Organization (v2vbn.org), we aim to deliver your orders in a timely and secure manner. Please review our Shipping and Exchange Policy carefully before making any purchase.
          </p>

          <div className="policy-section">
            <h3 className="title">Shipping Policy</h3>
            <p className="description">We offer shipping services across India. Our shipping policy includes:</p>
            <ul className="policy-list">
              <li>Orders are processed within 2–5 business days after payment confirmation.</li>
              <li>Delivery timelines may vary based on location, availability, and courier partner.</li>
              <li>Tracking details will be shared via email/SMS once the product is dispatched.</li>
              <li>Shipping charges, if any, will be displayed at checkout.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3 className="title">Delayed or Undelivered Items</h3>
            <p className="description">
              While we strive to ensure on-time delivery, delays may occur due to unforeseen circumstances. If your order is significantly delayed or marked undelivered, please reach out to us immediately at <Link to="mailto:admin@v2vbn.org" style={{ color: "#333" }}>admin@v2vbn.org</Link>.
            </p>
          </div>

          <div className="policy-section">
            <h3 className="title">Exchange Policy</h3>
            <p className="description">Exchanges are accepted under the following conditions:</p>
            <ul className="policy-list">
              <li>Products are eligible for exchange only if they are defective, damaged, or delivered incorrectly.</li>
              <li>The request must be made within 3 days of receiving the product.</li>
              <li>The product must be unused, in original packaging, and returned with proof of purchase.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3 className="title">Non-Exchangeable Items</h3>
            <p className="description">The following items are not eligible for exchange:</p>
            <ul className="policy-list">
              <li>Products damaged due to misuse or improper handling.</li>
              <li>Customized or made-to-order items.</li>
              <li>Digital services or content already delivered.</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3 className="title">How to Request an Exchange</h3>
            <p className="description">
              To request an exchange, please contact us at:
            </p>
            <ul className="policy-list">
              <li>📧 Email: <Link to="mailto:admin@v2vbn.org" style={{ color: "#333" }}>admin@v2vbn.org</Link></li>
              <li>Include your Order ID, reason for exchange, and images of the issue (if applicable).</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3 className="title">Policy Updates</h3>
            <p className="description">
              v2vbn.org reserves the right to update or modify this Shipping and Exchange Policy at any time. We recommend reviewing this page periodically.
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
  


          </main>
        </div>
        {/* End Breadcrumb area  */}


    </div>
  )
}

export default Shippingexchange